export const LARGE_GAME_TEAMS = 20;

export const MAX_TEAMS_POINTS = 5;
